var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgPdfButton = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1234",
    "data-name": "Group 1234",
    transform: "translate(-1737 -281)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5",
    "data-name": "Ellipse 5",
    cx: 25,
    cy: 25,
    r: 25,
    transform: "translate(1737 281)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("g", {
    id: "archivo-pdf",
    transform: "translate(1685.059 290)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M87.776,8.8,80.982,2H67.2a1.1,1.1,0,0,0-1.1,1.1V22.545H87.776Z",
    fill: "#eff3f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M326.8,7.7a1.1,1.1,0,0,0,1.1,1.1h5.7L326.8,2Z",
    transform: "translate(-245.818 0)",
    fill: "#dbdfe0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M66.2,361.8v7.364a1.1,1.1,0,0,0,1.1,1.1H86.78a1.1,1.1,0,0,0,1.1-1.1V361.8Z",
    transform: "translate(-0.094 -339.26)",
    fill: "#f1786b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_60",
    "data-name": "Group 60",
    transform: "translate(69.862 4.666)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M133.525,65.329a1.539,1.539,0,0,1-.993-.388,1.285,1.285,0,0,1-.508-1.239c.251-1.467,2.98-2.809,4.567-3.471a52.164,52.164,0,0,0,2.072-6.6c-.925-1.981-1.25-3.38-.965-4.173a1.118,1.118,0,0,1,.845-.742l.057-.011.057.006a1.233,1.233,0,0,1,.782.514,3.645,3.645,0,0,1,.285,2.8c-.068.365-.183.891-.331,1.519a36.144,36.144,0,0,0,3,5.046,9.431,9.431,0,0,1,2.232-.086c1.216.126,1.473.656,1.519.965a1.17,1.17,0,0,1-.828,1.159,2.629,2.629,0,0,1-3.1-1.1c-.046-.057-.091-.12-.137-.183a24.781,24.781,0,0,0-4.464,1.233c-.166.063-.325.126-.485.188-1.068,2.615-2.112,4.116-3.111,4.476A1.365,1.365,0,0,1,133.525,65.329Zm2.683-4.173c-2.266,1.022-3.391,2.032-3.494,2.666a.586.586,0,0,0,.268.588.773.773,0,0,0,.811.177C134.586,64.3,135.431,62.932,136.208,61.156Zm6.679-1.924a1.894,1.894,0,0,0,2.164.754c.274-.114.428-.308.411-.417s-.274-.308-.9-.371A8.4,8.4,0,0,0,142.887,59.232Zm-3.745-4.647c-.348,1.342-.822,2.957-1.376,4.521-.1.268-.188.525-.285.776a26.947,26.947,0,0,1,4.156-1.17A37.746,37.746,0,0,1,139.142,54.586Zm-.514-5.166a.412.412,0,0,0-.268.28,4.776,4.776,0,0,0,.571,2.8q.069-.325.12-.6c.263-1.421.011-2.032-.166-2.266A.639.639,0,0,0,138.628,49.419Z",
    transform: "translate(-132.006 -48.7)",
    fill: "#f1786b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_61",
    "data-name": "Group 61",
    transform: "translate(71.335 24.11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M310.192,391.521h-1.307v-1.33h1.307a.445.445,0,0,0,0-.891h-1.747a.446.446,0,0,0-.445.445v4.43a.445.445,0,0,0,.891,0v-1.77H310.2a.442.442,0,1,0-.006-.885Z",
    transform: "translate(-299.426 -389.3)",
    fill: "#eff3f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M159.147,389.4h-.9a.446.446,0,0,0-.445.445v4.43a.445.445,0,0,0,.891,0v-1.77h.457a1.553,1.553,0,0,0,0-3.106Zm0,2.215h-.457v-1.33h.457a.665.665,0,0,1,0,1.33Z",
    transform: "translate(-157.8 -389.394)",
    fill: "#eff3f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M221.81,389.4h-1.165a.446.446,0,0,0-.445.445v4.43a.446.446,0,0,0,.445.445h1.165a2.66,2.66,0,1,0,0-5.32Zm0,4.424h-.719v-3.545h.719a1.773,1.773,0,0,1,0,3.545Z",
    transform: "translate(-216.638 -389.394)",
    fill: "#eff3f5"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPdfButton, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/pdf-button.edd23805.svg";
export { ForwardRef as ReactComponent };